import service from './src/index';

export default {
    install(Vue) {
        Vue.prototype.$couplet = service;
    },
    service
}